import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import {
  CreateFlowDefinitionRequestDto,
  ListFlowDefinitionRequestDto,
  UpdateFlowDefinitionRequestDto,
  UpdateFlowGroupsRequestDto,
  UpdateFlowStateRequestDto,
  UpdateFlowStepsRequestDto,
} from '@domain/flow-definition/dtos/flow-definition-request.dtos';
import { FlowDefinitionResponseDto } from '@domain/flow-definition/dtos/flow-definition-response.dto';

// Rutas espejo del FlowController de kipey-core (/flow/definition/...).
@Injectable({
  providedIn: 'root',
})
export class FlowDefinitionService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('flow/definition');
  }

  list(request: ListFlowDefinitionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<FlowDefinitionResponseDto>>
    >(queryUrl, {
      params: { ...request } as any,
    });
  }

  show(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/show/${request.refId}`;
    return this.http.get<ApiResponse<FlowDefinitionResponseDto>>(queryUrl);
  }

  create(request: CreateFlowDefinitionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/`;
    return this.http.post<ApiResponse<FlowDefinitionResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(request: UpdateFlowDefinitionRequestDto) {
    const { refId, ...body } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<FlowDefinitionResponseDto>>(
      queryUrl,
      body,
    );
  }

  updateSteps(request: UpdateFlowStepsRequestDto) {
    const { refId, ...body } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/steps`;
    return this.http.put<ApiResponse<FlowDefinitionResponseDto>>(
      queryUrl,
      body,
    );
  }

  updateGroups(request: UpdateFlowGroupsRequestDto) {
    const { refId, ...body } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/groups`;
    return this.http.put<ApiResponse<FlowDefinitionResponseDto>>(
      queryUrl,
      body,
    );
  }

  publish(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/${request.refId}/publish`;
    return this.http.post<ApiResponse<FlowDefinitionResponseDto>>(queryUrl, {});
  }

  updateState(request: UpdateFlowStateRequestDto) {
    const { refId, ...body } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/state`;
    return this.http.patch<ApiResponse<FlowDefinitionResponseDto>>(
      queryUrl,
      body,
    );
  }

  delete(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/${request.refId}`;
    return this.http.delete<ApiResponse<FlowDefinitionResponseDto>>(queryUrl);
  }
}
